/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsMobileFooters = {
  init() {
    $(document).on('click', 'p.footer__heading', function (e) {
      event.preventDefault();

      if (window.matchMedia('(max-width: 798px)').matches) {
        var links = $(this).next();  
        links.toggle();
      }

      return false;
    });

    if (window.matchMedia('(max-width: 798px)').matches) {
      $(".block__newsletter").insertBefore("#shopify-section-link_list");
      $(".block__newsletter").show();
    }
  },

  unload() {
    $('p.footer__heading').off();
  },
};

/******/ })()
;